module.exports = __webpack_public_path__ + "static/media/pencil.8936af79.svg";